import MayoLanding from "../../tenants/mayo/patientFacing/common/MayoLanding";

import doctorImage from "../../assets/Mayo/lp_img.png";

export default function DemoPatientLanding() {
  return (<MayoLanding
      title={"Welcome to the Mayo Clinic TAVR Education Demo"}
      text={"GistMD’s AI platform creates personalized video prescriptions to boost patient engagement and adherence. In this demo, you will experience the avatar selection process exactly as a patient would"}
      image={doctorImage}
      buttonText={"Let's start"}
      navigateTo={"/demo/patient/choose-avatar"}
      postAnalyticType=""
      incluedTermsOfUse={false}
    />);
}